import { getLocalStorageTokenKey, isLocalStorageEnabled } from './localStorage';
import Axios from 'axios';
import i18n from './locale';

const authMiddleware = async (store, to, from, next) => {
    const isGuest = to.meta && to.meta.guest;
    const isAuth = to.meta && to.meta.auth;
    const token = getToken();

    if (isGuest && !isAuth) {
        if ((store.state.user || token) && (!to.meta && to.meta.auth)) {
            return next('/');
        }

        return next();
    } else {
        if (store.state.user) {
            return next();
        }

        if (!token) {
            if (isGuest) {
                return next();
            }

            return next('/login');
        }


        try {
            store.dispatch('setLoading', true);

            const response = await Axios.get('/api/user', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            store.dispatch('login', {
                user: response.data,
                token,
            });

            if (isGuest && !isAuth) {
                return next('/');
            }

            return next();
        } catch (exception) {
            store.dispatch('logout');

            return next('/login');
        }
    }
};

function getToken() {
    if (window.location.search.includes('token=')) {
        const url = new URL(window.location);

        return url.searchParams.get('token');
    }

    return isLocalStorageEnabled() ? localStorage.getItem(getLocalStorageTokenKey()) : null;
}

export function translateRoles(roles) {
    return roles.map(role => i18n.t('roles.' + role.name));
}

export default authMiddleware;
